import React, { useState } from "react";
import Alert from "@material-ui/lab/Alert";
import Box from "@material-ui/core/Box";
import format from "date-fns/format";

const PlannedMaintenanceBanner = ({ config }) => {
  const [closed, setClosed] = useState(false);

  if (!config?.plannedMaintenanceWillStartAt || closed) return null;

  const startDate = new Date(config.plannedMaintenanceWillStartAt);
  const formattedDate = format(startDate, "PPpp");
  const durationText =
    config.plannedMaintenanceDuration != null &&
    config.plannedMaintenanceDuration > 0
      ? ` (expected duration: ${config.plannedMaintenanceDuration} minute${
          config.plannedMaintenanceDuration !== 1 ? "s" : ""
        })`
      : "";

  return (
    <Box bottom={0} left={0} p={2} position="fixed" right={0} zIndex={1300}>
      <Alert severity="info" onClose={() => setClosed(true)}>
        Planned maintenance scheduled for {formattedDate}
        {durationText}.
      </Alert>
    </Box>
  );
};

export default PlannedMaintenanceBanner;
